import PhoneShell from '../components/shared/PhoneShell';
import BackHeader from '../components/shared/BackHeader';
import { useLang } from '../i18n';

const css = `
  .legal { padding: 6px 16px 32px; }
  .legal-hero { margin-bottom: 20px; padding: 16px 14px; border-radius: 12px; background: linear-gradient(135deg, rgba(129,135,246,.15), rgba(118,225,255,.06)); box-shadow: inset 0 0 0 1px rgba(118,225,255,.18); }
  .legal-hero-title { font-size: 17px; font-weight: 800; color: #fff; }
  .legal-hero-sub { font-size: 12px; color: #76e1ff; margin-top: 4px; }
  .legal-section { margin-top: 18px; }
  .legal-section-title { font-size: 13px; font-weight: 800; color: #fff; margin-bottom: 8px; letter-spacing: .2px; display: flex; align-items: center; gap: 7px; }
  .legal-section-title::before { content: ''; display: block; width: 3px; height: 14px; border-radius: 2px; background: linear-gradient(#8187f6, #76e1ff); flex: none; }
  .legal-p { font-size: 12.5px; color: #9b9ab0; line-height: 1.65; }
  .legal-p + .legal-p { margin-top: 8px; }
  .legal-date { font-size: 11px; color: #5a5972; margin-top: 28px; text-align: center; }
`;

const CONTENT = {
  fr: {
    backTitle: 'À propos',
    heroTitle: 'À propos de Roxs Sports',
    heroSub: 'La plateforme de paris sportifs en ligne',
    footer: '© 2025 Roxs Sports — Tous droits réservés',
    sections: [
      {
        title: 'Notre mission',
        body: [
          'Roxs Sports est une plateforme de paris sportifs en ligne dédiée à offrir une expérience de jeu sécurisée, transparente et divertissante à ses utilisateurs.',
          'Nous combinons technologie de pointe et expertise sportive pour proposer les meilleures cotes du marché sur plus de 30 sports et milliers d\'événements chaque semaine.',
        ],
      },
      {
        title: 'Qui sommes-nous ?',
        body: [
          'Fondée par une équipe passionnée de sport et de technologie, Roxs Sports s\'est imposée comme un acteur de référence dans le secteur des paris en ligne.',
          'Notre plateforme est agréée et régulée, garantissant à chaque utilisateur un environnement de jeu équitable et conforme aux réglementations en vigueur.',
        ],
      },
      {
        title: 'Nos valeurs',
        body: [
          'Transparence : des cotes claires, des règles lisibles, aucune surprise cachée.',
          'Responsabilité : nous promouvons un jeu responsable et mettons à disposition des outils de contrôle pour chaque utilisateur.',
          'Innovation : nous investissons continuellement pour améliorer votre expérience, que ce soit sur mobile ou desktop.',
        ],
      },
      {
        title: 'Nous contacter',
        body: [
          'Pour toute question, vous pouvez nous joindre via notre Centre d\'aide ou par email à support@roxs-sports.com.',
        ],
      },
    ],
  },
  es: {
    backTitle: 'Acerca de',
    heroTitle: 'Acerca de Roxs Sports',
    heroSub: 'La plataforma de apuestas deportivas en línea',
    footer: '© 2025 Roxs Sports — Todos los derechos reservados',
    sections: [
      {
        title: 'Nuestra misión',
        body: [
          'Roxs Sports es una plataforma de apuestas deportivas en línea dedicada a ofrecer una experiencia de juego segura, transparente y entretenida a sus usuarios.',
          'Combinamos tecnología de vanguardia y experiencia deportiva para ofrecer las mejores cuotas del mercado en más de 30 deportes y miles de eventos cada semana.',
        ],
      },
      {
        title: '¿Quiénes somos?',
        body: [
          'Fundada por un equipo apasionado por el deporte y la tecnología, Roxs Sports se ha consolidado como un referente en el sector de las apuestas en línea.',
          'Nuestra plataforma está autorizada y regulada, garantizando a cada usuario un entorno de juego justo y conforme a la normativa vigente.',
        ],
      },
      {
        title: 'Nuestros valores',
        body: [
          'Transparencia: cuotas claras, reglas legibles, sin sorpresas ocultas.',
          'Responsabilidad: promovemos el juego responsable y ponemos a disposición herramientas de control para cada usuario.',
          'Innovación: invertimos continuamente para mejorar su experiencia, tanto en móvil como en escritorio.',
        ],
      },
      {
        title: 'Contáctenos',
        body: [
          'Para cualquier consulta, puede contactarnos a través de nuestro Centro de ayuda o por correo electrónico a support@roxs-sports.com.',
        ],
      },
    ],
  },
  pt: {
    backTitle: 'Sobre',
    heroTitle: 'Sobre a Roxs Sports',
    heroSub: 'A plataforma de apostas esportivas online',
    footer: '© 2025 Roxs Sports — Todos os direitos reservados',
    sections: [
      {
        title: 'Nossa missão',
        body: [
          'A Roxs Sports é uma plataforma de apostas esportivas online dedicada a oferecer uma experiência de jogo segura, transparente e divertida aos seus usuários.',
          'Combinamos tecnologia de ponta e expertise esportiva para oferecer as melhores odds do mercado em mais de 30 esportes e milhares de eventos por semana.',
        ],
      },
      {
        title: 'Quem somos?',
        body: [
          'Fundada por uma equipe apaixonada por esporte e tecnologia, a Roxs Sports consolidou-se como referência no setor de apostas online.',
          'Nossa plataforma é licenciada e regulamentada, garantindo a cada usuário um ambiente de jogo justo e em conformidade com as regulamentações vigentes.',
        ],
      },
      {
        title: 'Nossos valores',
        body: [
          'Transparência: odds claras, regras legíveis, sem surpresas ocultas.',
          'Responsabilidade: promovemos o jogo responsável e disponibilizamos ferramentas de controle para cada usuário.',
          'Inovação: investimos continuamente para melhorar sua experiência, tanto no celular quanto no desktop.',
        ],
      },
      {
        title: 'Fale conosco',
        body: [
          'Para qualquer dúvida, você pode nos contatar pela nossa Central de ajuda ou por e-mail em support@roxs-sports.com.',
        ],
      },
    ],
  },
  en: {
    backTitle: 'About',
    heroTitle: 'About Roxs Sports',
    heroSub: 'The online sports betting platform',
    footer: '© 2025 Roxs Sports — All rights reserved',
    sections: [
      {
        title: 'Our mission',
        body: [
          'Roxs Sports is an online sports betting platform dedicated to offering a secure, transparent and entertaining gaming experience to its users.',
          'We combine cutting-edge technology and sports expertise to offer the best odds on the market across more than 30 sports and thousands of events every week.',
        ],
      },
      {
        title: 'Who are we?',
        body: [
          'Founded by a team passionate about sport and technology, Roxs Sports has established itself as a leading player in the online betting sector.',
          'Our platform is licensed and regulated, guaranteeing every user a fair gaming environment compliant with the regulations in force.',
        ],
      },
      {
        title: 'Our values',
        body: [
          'Transparency: clear odds, readable rules, no hidden surprises.',
          'Responsibility: we promote responsible gaming and provide control tools for every user.',
          'Innovation: we invest continuously to improve your experience, whether on mobile or desktop.',
        ],
      },
      {
        title: 'Contact us',
        body: [
          'For any question, you can reach us via our Help Center or by email at support@roxs-sports.com.',
        ],
      },
    ],
  },
  it: {
    backTitle: 'Chi siamo',
    heroTitle: 'Chi è Roxs Sports',
    heroSub: 'La piattaforma di scommesse sportive online',
    footer: '© 2025 Roxs Sports — Tutti i diritti riservati',
    sections: [
      {
        title: 'La nostra missione',
        body: [
          'Roxs Sports è una piattaforma di scommesse sportive online dedicata a offrire ai suoi utenti un\'esperienza di gioco sicura, trasparente e divertente.',
          'Uniamo tecnologia all\'avanguardia ed esperienza sportiva per offrire le migliori quote del mercato su oltre 30 sport e migliaia di eventi ogni settimana.',
        ],
      },
      {
        title: 'Chi siamo?',
        body: [
          'Fondata da un team appassionato di sport e tecnologia, Roxs Sports si è affermata come punto di riferimento nel settore delle scommesse online.',
          'La nostra piattaforma è autorizzata e regolamentata, garantendo a ogni utente un ambiente di gioco equo e conforme alle normative vigenti.',
        ],
      },
      {
        title: 'I nostri valori',
        body: [
          'Trasparenza: quote chiare, regole leggibili, nessuna sorpresa nascosta.',
          'Responsabilità: promuoviamo il gioco responsabile e mettiamo a disposizione strumenti di controllo per ogni utente.',
          'Innovazione: investiamo continuamente per migliorare la tua esperienza, sia su mobile che su desktop.',
        ],
      },
      {
        title: 'Contattaci',
        body: [
          'Per qualsiasi domanda, puoi contattarci tramite il nostro Centro assistenza o via email a support@roxs-sports.com.',
        ],
      },
    ],
  },
  nl: {
    backTitle: 'Over ons',
    heroTitle: 'Over Roxs Sports',
    heroSub: 'Het online sportweddenschappenplatform',
    footer: '© 2025 Roxs Sports — Alle rechten voorbehouden',
    sections: [
      {
        title: 'Onze missie',
        body: [
          'Roxs Sports is een online sportweddenschappenplatform dat zich toelegt op het bieden van een veilige, transparante en vermakelijke spelervaring aan zijn gebruikers.',
          'Wij combineren geavanceerde technologie en sportexpertise om de beste odds op de markt te bieden op meer dan 30 sporten en duizenden evenementen per week.',
        ],
      },
      {
        title: 'Wie zijn wij?',
        body: [
          'Opgericht door een team met een passie voor sport en technologie, heeft Roxs Sports zich gevestigd als een toonaangevende speler in de online weddenschappensector.',
          'Ons platform is gelicentieerd en gereguleerd, wat elke gebruiker een eerlijke spelomgeving garandeert die voldoet aan de geldende regelgeving.',
        ],
      },
      {
        title: 'Onze waarden',
        body: [
          'Transparantie: duidelijke odds, leesbare regels, geen verborgen verrassingen.',
          'Verantwoordelijkheid: wij promoten verantwoord spelen en bieden controletools voor elke gebruiker.',
          'Innovatie: wij investeren voortdurend om je ervaring te verbeteren, zowel op mobiel als op desktop.',
        ],
      },
      {
        title: 'Contact opnemen',
        body: [
          'Voor vragen kun je ons bereiken via ons Helpcentrum of per e-mail op support@roxs-sports.com.',
        ],
      },
    ],
  },
  tr: {
    backTitle: 'Hakkımızda',
    heroTitle: 'Roxs Sports Hakkında',
    heroSub: 'Çevrimiçi spor bahisleri platformu',
    footer: '© 2025 Roxs Sports — Tüm hakları saklıdır',
    sections: [
      {
        title: 'Misyonumuz',
        body: [
          'Roxs Sports, kullanıcılarına güvenli, şeffaf ve eğlenceli bir oyun deneyimi sunmaya adanmış çevrimiçi bir spor bahisleri platformudur.',
          'En son teknolojiyi ve spor uzmanlığını birleştirerek 30\'dan fazla sporda ve her hafta binlerce etkinlikte piyasanın en iyi oranlarını sunuyoruz.',
        ],
      },
      {
        title: 'Biz kimiz?',
        body: [
          'Spor ve teknoloji tutkunu bir ekip tarafından kurulan Roxs Sports, çevrimiçi bahis sektöründe önde gelen bir oyuncu olarak kendini kanıtlamıştır.',
          'Platformumuz lisanslı ve düzenlenmiştir; bu da her kullanıcıya yürürlükteki düzenlemelere uygun, adil bir oyun ortamı garanti eder.',
        ],
      },
      {
        title: 'Değerlerimiz',
        body: [
          'Şeffaflık: net oranlar, okunabilir kurallar, gizli sürprizler yok.',
          'Sorumluluk: sorumlu oyunu teşvik ediyor ve her kullanıcı için kontrol araçları sunuyoruz.',
          'Yenilik: deneyiminizi geliştirmek için hem mobil hem masaüstünde sürekli yatırım yapıyoruz.',
        ],
      },
      {
        title: 'Bize ulaşın',
        body: [
          'Her türlü soru için Yardım Merkezimiz aracılığıyla veya support@roxs-sports.com e-posta adresinden bize ulaşabilirsiniz.',
        ],
      },
    ],
  },
  el: {
    backTitle: 'Σχετικά',
    heroTitle: 'Σχετικά με τη Roxs Sports',
    heroSub: 'Η διαδικτυακή πλατφόρμα αθλητικού στοιχηματισμού',
    footer: '© 2025 Roxs Sports — Με επιφύλαξη παντός δικαιώματος',
    sections: [
      {
        title: 'Η αποστολή μας',
        body: [
          'Η Roxs Sports είναι μια διαδικτυακή πλατφόρμα αθλητικού στοιχηματισμού αφιερωμένη στην προσφορά μιας ασφαλούς, διαφανούς και ψυχαγωγικής εμπειρίας παιχνιδιού στους χρήστες της.',
          'Συνδυάζουμε τεχνολογία αιχμής και αθλητική εμπειρογνωμοσύνη για να προσφέρουμε τις καλύτερες αποδόσεις της αγοράς σε περισσότερα από 30 αθλήματα και χιλιάδες γεγονότα κάθε εβδομάδα.',
        ],
      },
      {
        title: 'Ποιοι είμαστε;',
        body: [
          'Ιδρυμένη από μια ομάδα με πάθος για τον αθλητισμό και την τεχνολογία, η Roxs Sports έχει καθιερωθεί ως κορυφαίος παίκτης στον τομέα του διαδικτυακού στοιχηματισμού.',
          'Η πλατφόρμα μας είναι αδειοδοτημένη και ρυθμιζόμενη, εγγυώμενη σε κάθε χρήστη ένα δίκαιο περιβάλλον παιχνιδιού σύμφωνο με τους ισχύοντες κανονισμούς.',
        ],
      },
      {
        title: 'Οι αξίες μας',
        body: [
          'Διαφάνεια: σαφείς αποδόσεις, ευανάγνωστοι κανόνες, καμία κρυφή έκπληξη.',
          'Υπευθυνότητα: προωθούμε το υπεύθυνο παιχνίδι και παρέχουμε εργαλεία ελέγχου για κάθε χρήστη.',
          'Καινοτομία: επενδύουμε συνεχώς για να βελτιώσουμε την εμπειρία σας, τόσο σε κινητά όσο και σε υπολογιστές.',
        ],
      },
      {
        title: 'Επικοινωνήστε μαζί μας',
        body: [
          'Για οποιαδήποτε ερώτηση, μπορείτε να επικοινωνήσετε μαζί μας μέσω του Κέντρου βοήθειας ή μέσω email στο support@roxs-sports.com.',
        ],
      },
    ],
  },
  ro: {
    backTitle: 'Despre',
    heroTitle: 'Despre Roxs Sports',
    heroSub: 'Platforma de pariuri sportive online',
    footer: '© 2025 Roxs Sports — Toate drepturile rezervate',
    sections: [
      {
        title: 'Misiunea noastră',
        body: [
          'Roxs Sports este o platformă de pariuri sportive online dedicată oferirii unei experiențe de joc sigure, transparente și distractive utilizatorilor săi.',
          'Combinăm tehnologia de vârf și expertiza sportivă pentru a oferi cele mai bune cote de pe piață la peste 30 de sporturi și mii de evenimente în fiecare săptămână.',
        ],
      },
      {
        title: 'Cine suntem?',
        body: [
          'Fondată de o echipă pasionată de sport și tehnologie, Roxs Sports s-a impus ca un jucător de referință în sectorul pariurilor online.',
          'Platforma noastră este licențiată și reglementată, garantând fiecărui utilizator un mediu de joc echitabil și conform cu reglementările în vigoare.',
        ],
      },
      {
        title: 'Valorile noastre',
        body: [
          'Transparență: cote clare, reguli ușor de citit, fără surprize ascunse.',
          'Responsabilitate: promovăm jocul responsabil și punem la dispoziție instrumente de control pentru fiecare utilizator.',
          'Inovație: investim continuu pentru a vă îmbunătăți experiența, atât pe mobil, cât și pe desktop.',
        ],
      },
      {
        title: 'Contactați-ne',
        body: [
          'Pentru orice întrebare, ne puteți contacta prin Centrul nostru de ajutor sau prin email la support@roxs-sports.com.',
        ],
      },
    ],
  },
};

export default function About() {
  const { lang } = useLang();
  const c = CONTENT[lang] || CONTENT.fr;
  return (
    <PhoneShell activeTab="">
      <style>{css}</style>
      <BackHeader title={c.backTitle} />
      <div className="legal">
        <div className="legal-hero">
          <div className="legal-hero-title">{c.heroTitle}</div>
          <div className="legal-hero-sub">{c.heroSub}</div>
        </div>
        {c.sections.map((s) => (
          <div key={s.title} className="legal-section">
            <div className="legal-section-title">{s.title}</div>
            {s.body.map((p, i) => <p key={i} className="legal-p">{p}</p>)}
          </div>
        ))}
        <div className="legal-date">{c.footer}</div>
      </div>
    </PhoneShell>
  );
}
